<template>
  <v-row class="ma-0" no-gutters style="overflow-x: hidden">
    <v-col cols="12">
      <component
        v-for="(component, index) in structure"
        :key="index"
        v-bind:is="component"
        :wrap="true"
        class="mb-3"
      />
    </v-col>
  </v-row>
</template>

<script>
import AppDownloadButtons from '@/components/homepage/appDownload/AppDownloadButtonsClassic.vue';
import ActivityCalendarClassic from '@/components/homepage/ActivityCalendarClassic.vue';
import UserFavourites from '@/components/homepage/UserFavourites.vue';
import AllCategories from '@/components/homepage/AllCategories.vue';
import AllActivities from '@/components/homepage/AllActivities.vue';
import BannerTextBlock from '@/components/homepage/BannerTextBlock.vue';
import TrendingItems from '@/components/homepage/TrendingItems.vue';
import AdditionalInfo from '@/components/homepage/AdditionalInfo.vue';
import PartnerInformation from '@/components/homepage/PartnerInformation.vue';
import Reviews from '@/components/homepage/Reviews.vue';
import TemplateEvents from '@/components/homepage/TemplateEvents.vue';
import Benefits from '@/components/homepage/Benefits';
import BlogEvents from '@/components/homepage/BlogEvents';

export default {
  name: 'HomepageContainer',
  components: {
    AppDownloadButtons,
    ActivityCalendarClassic,
    UserFavourites,
    AllCategories,
    AllActivities,
    BannerTextBlock,
    TrendingItems,
    AdditionalInfo,
    PartnerInformation,
    Reviews,
    TemplateEvents,
    Benefits,
    BlogEvents,
  },
  props: {
    structure: Array,
  },
};
</script>
